export const ENROLLMENT_DECLINED = 'ENROLLMENT_DECLINED';

export const enrollmentDeclined = () => dispatch =>
  dispatch({
    type: ENROLLMENT_DECLINED,
  });
